import { Component, Input } from "@angular/core";
import { BrowserModule, DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "portfolio-work-description",
  templateUrl: "./portfolio-description.component.html",
  styleUrls: ["./portfolio-description.component.scss"],
})
export class PortfolioDescriptionComponent {
  @Input() bgColor: string;
  @Input() projectTitle: string;
  @Input() projectTitle2: string;
  @Input() projectMainDescription: string;
  @Input() projectDescription1: string;
  @Input() projectDescription2: string;
  @Input() projectImgDescription: string;
  @Input() altImgTitle: string;
  @Input() projectIcon: string;
  @Input() marvelUrlSrc: string;
  @Input() projectTags: string[];
  @Input() tagsColor: string;
  @Input() projectLists: string[];
}



// WEBPACK FOOTER //
// ./src/app/shared/portfolio-description/portfolio-description.component.ts